<template>
  <div>
    <div
      id="app"
      :style="
      $route.name === 'Search' || $route.name === 'home'
        ? 'overflow:hidden'
        : ''
    "
    >
      <!-- v-if="$route.path != '/'" -->
      <Header></Header>
      <div class="flex-grow">
        <!-- <keep-alive v-if="$route.meta && $route.meta.keepAlive"> -->
        <!-- class="animate__animated animate__fadeInLeft" -->
        <router-view></router-view>
        <!-- </keep-alive>
        <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view> -->
      </div>

      <el-dialog
        :visible.sync="dialogFormVisible"
        width="728px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="toggleDialog"
      >
        <div class="bindmobile">
          <div class="bindmobiletitle">
            <!-- <img src="/static/icon/touxiang.jpeg" alt="" /><span>Hi,老毛</span> -->

            <el-avatar
              shape="square"
              :size="64"
              :src="userinfo && userinfo.avatar"
              style="margin-right: 20px"
            ></el-avatar
            ><span>Hi,{{ userinfo && userinfo.nickName }}</span>
          </div>
          <div class="bindmobiletishi">
            <span>綁定手機，便於下次快速登録</span>
          </div>
          <el-form
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            style="margin-top: 40px"
          >
            <el-form-item label="手機號" prop="name">
              <el-input placeholder="請輸入手機號" v-model="changemobile.mobile">
                <el-select
                  v-model="ac"
                  class="ac-ipt"
                  slot="prepend"
                  style="width: 100px"
                >
                  <el-option
                    v-for="item in codeList"
                    :key="item"
                    :value="item"
                    :label="'+' + item"
                  />
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="驗證碼" prop="name">
              <el-input
                placeholder="請輸入驗證碼"
                style="width: 62%"
                v-model="changemobile.smsCode"
              ></el-input
              ><el-button
              @click.prevent="getSMSNew()"
              type="primary"
              plain
              style="width: 132px"
            >{{ changemobile.text }}</el-button
            >
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center; margin-bottom: 50px"
        >
          <el-button type="primary" @click="bindMobil()"
          >登録并綁定手機</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        v-if="($route.name != 'Login')&&(!ipAdressLogin)"
        :visible.sync="loginDialogVisible"
        width="51rem"
        top="20vh"
        :before-close="handleClose"
        custom-class="loginbox"
      >
<!--        <loginBox v-if="$route.name != 'Login'"></loginBox>-->
        <loginOpen v-if="$route.name != 'Login'" @closeOpen="closeOpen"></loginOpen>
      </el-dialog>
      <addReadList></addReadList>
    </div>
    <Footer
      v-if="
        $route.name != 'Home' &&
        $route.name != 'viewer' &&
        $route.name != 'Login'
      "
    ></Footer>
  </div>

</template>

<script>
import eventBus from "@/utils/eventBus.js"
import Header from "./components/header.vue"
import Footer from "./components/footer.vue"
import addReadList from "./components/addreadlist.vue"
import { getArticleList, getHanMap, getInfo, smsCode, changeMobile, getPhoneCode, addLatest,isCompanyUser } from "./api/api"
export default {
  components: {
    Header,
    Footer,
    addReadList
  },
  name: "App",
  data: () => {
    return {
      baseUrl: window.__baseUrl__,
      dialogFormVisible: false,
      loginDialogVisible: false,//登录弹窗
      ipAdressLogin: false,
      keep: false,
      changemobile: {
        mobile: "",
        smsCode: "",
        text: "獲取驗證碼",
        timer: null,
        uuid: ""
      },
      userinfo: {},
      ac: "",
      codeList: [],
      ispaypath: false
      // backUrl: ""

      // indexShow:false,
      // isLogin: false,
      // isVip: false,//是否vip
    }
  },
  watch: {
    $route: (val) => (this.keep = val.meta.keepAlive),
    // 监听路由变化，确保从A页面切换到其他页面时头部显示
  },
  created () {
    // 添加点击事件监听
    if (this.$route.path != "/viewer") { document.addEventListener('mousedown', this.handleClick) }

    eventBus.$on("getUserInfo", () => {
      this.getUserInfo()
    })

    eventBus.$on("busGetMaps", () => {
      this.getMaps()
    })

    eventBus.$on("doChangeloginVisible", (val) => {
      this.doChangeloginVisible(val)
    })
    isCompanyUser().then(res => {
      if(res.code === 200){
        if(res.data){
          if(res.data.ip){
            this.ipAdressLogin=true
          }else {
            this.ipAdressLogin=false
          }


        }
      }
    })


    // this.$bus.$on("openBindMobile", this.openBindMobile())
    // eventBus.$on("outLogin", type => {
    //   this.isLogin = localStorage.getItem("token") ? true : false
    // })
    // eventBus.$on("getout", this.getout())
    // getArticleList().then(res => {
    //   console.log(res);
    // })
    // this.indexShow = this.$route.meta.indexShow?this.$route.meta.indexShow:false;
    // console.log(this.indexShow,'indexShow');
  },
  mounted () {
    //操作记录
    eventBus.$on("addLatestNew", (path, operType, operStr) => {
      this.addLatestNew(path, operType, operStr)
    })

    // this.isVip = localStorage.getItem('isVip') == 'null' ? false : localStorage.getItem('isVip')
    // this.isLogin = localStorage.getItem("token") ? true : false
    // this.getUserInfo()
    // console.log(document.referrer, 'document.referrer')
    this.userinfo = localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {}
    //获取区号
    getPhoneCode().then(res => {
      this.codeList = res.data || []
      this.ac = this.codeList[0] || ""
    })
    //绑定手机号
    // this.openBindMobileBox()
    eventBus.$on("openBindMobile", (open) => {
      this.openBindMobileBox(open)
    })



    if (localStorage.token && !localStorage.datamap) {
      this.getMaps()//字体表获取
    }

    window.addEventListener('beforeunload', this.addLatestNew()) // 监听页面刷新
  },
  methods: {
    closeOpen(){
      this.loginDialogVisible=false
    },
    //第二版更详细操作记录 type=1路由跳转 或 刷新页面
    addLatestNew (type = 1, operType = "", operStr = "") {
      // console.log(this.$route, 'path')
      let paramOperType = ""
      let paramOperStr = operStr
      if (type == 1) {
        switch (this.$route.name) {

          case 'Home':
            paramOperType = "home"
            break
          case 'About':
            paramOperType = "about"
            break
          case 'productInfo':
            paramOperType = "project"
            break
          case 'Search':
            paramOperType = "search"
            break
          // case 'viewer': //在页面已记录
          //   paramOperType = "read"
          //   break
          case 'bookDetail':
            paramOperType = "detail"
            paramOperStr = JSON.stringify({ bookId: this.$route.query.id })
            break
          case 'Uc':
            paramOperType = "my-read"
            break
          case 'Login':
            paramOperType = "login"
            break
          case 'platformLogin':
            paramOperType = "platlogin"
            break
          case 'Products':
            paramOperType = "pay"
            break

        }

      } else {

        paramOperType = operType
      }

      let guestId = this.$getUUID()

      let param = {
        guestId: guestId,
        operType: paramOperType,
        operStr: paramOperStr
      }
      // console.log(param, 'param')
      // if (paramOperType) {
      //   addLatest(
      //     param
      //   ).then((e) => {
      //     console.log(e, 'latest')
      //   })
      // }

    },
    handleClick (event) {

      if (event.button === 0) {


        // 处理点击事件
        // console.log('Clicked at:', event)
        let charge = event.target.id || event.target.name
        let clicktext = event.target.innerText
        let operType = ""
        // console.log(charge, 'charge')
        if (charge == 'tab-read') {
          operType = "my-read"
        } else if (charge == 'tab-note') {
          operType = "my-note"
        } else if (charge == 'tab-collect') {
          operType = "my-favor"
        } else if (charge == 'tab-order') {
          operType = "my-order"
        } else if (clicktext == '導出檢索結果 ') {
          operType = "export"
        } else if (clicktext == '數據分析' || (charge && charge.indexOf('tab-first') != -1)) {
          operType = "analyze-cat"
        } else if (charge && charge.indexOf('tab-second') != -1) {
          operType = "analyze-book"
        } else if (charge && charge.indexOf('tab-three') != -1) {
          operType = "analyze-dynasty"
        } else if (charge && charge.indexOf('his_jiaoji') != -1) {
          operType = "jiaoji"
        } else if (charge && charge.indexOf('his_mark') != -1) {
          operType = "mark"
        } else if (charge && charge.indexOf('his_feedback') != -1) {
          operType = "feedback"
        } else if (charge && charge.indexOf('his_wordcount') != -1) {
          operType = "word-count"
        } else if (charge && charge.indexOf('his_note') != -1) {
          operType = "note"
        }
        if (operType) this.addLatestNew(2, operType)

      }
      // console.log(operType, 'operType')

    },

    handleClose (done) {
      // eventBus.$emit('doChangeloginVisible', false)
      eventBus.$emit("noparam")
      done()
    },
    doChangeloginVisible (val) {
      this.loginDialogVisible = val
    },
    openBindMobileBox (open = false) {
      this.ispaypath = open  //是否支付页面过来
      // isCompany是否总平台用户  isCompany字段 0 否 1是
      getInfo().then(d => {
        if (d.code == 200) {
          if ((d.user.isCompany == 0 || open) && (!d.user.mobile || d.user.mobile == '')) {
            this.dialogFormVisible = true
          }
          // else {
          //   this.dialogFormVisible = true //测试完删除
          // }

        } else {

          this.$message.error(d.msg)
        }
      })


    },
    getUserInfo () {
      getInfo().then(d => {
        localStorage.setItem('isVip', d.user && d.user.vipValidityDate)
        let userinfo = d.user
        if (userinfo) {
          userinfo.avatar = userinfo.avatar ? (userinfo.avatar.indexOf('http') == -1) ? this.baseUrl + userinfo.avatar : userinfo.avatar : '/static/logo33.png'
        }
        this.userinfo = userinfo
        localStorage.setItem('userinfo', JSON.stringify(userinfo))
        eventBus.$emit("outLogin", 1)
      })
    },
    toggleDialog (done) {
      if (this.userinfo.isCompany == 1) {
        done()
        this.$bus.$emit("doChangeVisible", false) //同时关掉支付窗口 不允许支付

      } else {
        this.$message.error("請先綁定手機號碼")
      }
    },
    //绑定手机号
    bindMobil () {
      let { mobile, smsCode, uuid } = this.changemobile
      if (!/^[0-9]*$/.test(mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }
      changeMobile({ mobile: this.ac + mobile, smsCode, uuid, scene: "BIND" }).then((res) => {
        if (res.code == 200) {
          this.dialogFormVisible = false
          if (res.token) {
            localStorage.setItem("token", "Bearer " + res.token)
          }
          //平台用户只有在支付的时候绑定手机号
          // getInfo().then(d => {
          //   if (d.code == 200 && d.user.isCompany == 1) {
          //     this.$bus.$emit("getImgCode") //打开支付码
          //   }
          // })
          if (this.ispaypath) {
            this.$bus.$emit("getImgCode") //打开支付码
          }
          this.getUserInfo()
          this.$message.success("綁定成功")

        } else {
          this.$message.error(res.msg)
          //测试完删除
          // this.dialogFormVisible = false
          // getInfo().then(d => {
          //   if (d.code == 200 && d.user.isCompany == 1) {
          //     this.$bus.$emit("getImgCode") //打开支付码
          //   }
          // })
        }
      })

    },
    //获取用户信息
    // getUserInfo () {
    //   getInfo().then(d => {
    //     // console.log(d, 'userinfo')
    //     localStorage.setItem('isVip', d.user && d.user.vipValidityDate)
    //     this.userinfo = d.user

    //     eventBus.$emit("outLogin", 1)
    //   })
    // },
    //没绑定手机号
    // openBindMobile () {
    //   console.log(this.userinfo, 'this.userinfo')
    //   if (this.userinfo.mail == '' || !this.userinfo.mail) {
    //     console.log('232443')
    //     this.dialogFormVisible = true
    //   }
    // },
    // 微信登录绑定手机号发送
    getSMSNew () {

      // if (!/^[1][35789][0-9]{9}$/.test(this.changemobile.mobile)) {
      if (!/^[0-9]*$/.test(this.changemobile.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }

      if (this.changemobile.text === "獲取驗證碼") {
        smsCode({
          mobile: this.ac + this.changemobile.mobile,
          scene: "BIND"
        }).then(res => {
          if (res.code == 500) {
            this.$message.error(res.msg)
            return
          }
          let num = 60
          this.changemobile.timer = setInterval(() => {
            num--

            if (num === 0) {
              clearInterval(this.changemobile.timer)
              this.changemobile.timer = null
              this.changemobile.text = `獲取驗證碼`
            }
            else {
              this.changemobile.text = `重新獲取(${num}s)`
              // console.log(num,'num');
            }
          }, 1000)

          this.changemobile.uuid = res.uuid
          // this.form.smsCode = res.smsCode
        })
      } else {
      }
    },
    getMaps () {

      getHanMap().then((e) => {
        // console.log('3435')
        if (e.code == 200) {
          localStorage.setItem('datamap', JSON.stringify(e.data))
          localStorage.setItem('starttime', JSON.stringify(new Date().getTime()))
        }
      })
    }
  },
  beforeDestroy () {
    eventBus.$off('getUserInfo')
    eventBus.$off('openBindMobile')
    eventBus.$off('busGetMaps')
    eventBus.$off('doChangeloginVisible')
    eventBus.$off("addLatestNew")
    window.removeEventListener('beforeunload', this.addLatestNew())
    if (this.$route.path != "/viewer") { document.removeEventListener('mousedown', this.handleClick) }
  }
};
</script>

<style lang="less">
@import url(./assets/common.less);
// /deep/.el-tooltip__popper.is-light {
//   border: none;
// }
.bindmobile {
  width: 450px;
  margin: 0 auto;
  box-sizing: border-box;

  .bindmobiletitle {
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
      border-radius: 3px;
      margin-right: 20px;
    }
    span {
      font-size: 18px;
    }
  }
  .bindmobiletishi {
    margin-top: 60px;
    width: 100%;
    text-align: center;
    span {
      font-size: 14px;
    }
  }
}
.loginbox {
  border-radius: 10px;
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 0;
  }
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: #eee;
}
/*定义滑块 样式*/
::-webkit-scrollbar-thumb {
  height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}
html,
body,
#app {
  height: 100vh;
  min-width: 1200px;

  min-height: 768px;
  background: #f4f0e8;
}

#app {
  display: flex;
  flex-direction: column;
  // max-width: 1440px;
  margin: auto;
}

.flex-grow {
  flex: 1;
  flex-grow: 1;
  background: rgb(244, 240, 232);
}

@media screen and (max-width: 768px) {
  #app {
    max-width: 100%;
    margin: auto;
  }
}

body {
  margin: 0;
  padding: 0;
}

.header {
  height: 2rem;
  // padding-left: 3rem;
}

.menu {
  width: 3.467rem;
  height: 0.827rem;
  background: url("../static/menu/menu_bg.png") 100% no-repeat;
  background-size: 100% 100%;
}

.title {
  font-size: 0.8421rem;
}

.relative {
  position: relative;
}

.englishfont {
  font-family: "Arial, Helvetica, sans-serif";
}

.drag-box {
  position: absolute;
  left: 0;
  top: 0;
  cursor: ew-resize;
  width: 8px;
  height: 100%;
  z-index: 999;
}

#hightText {
  // color: #3366cc;
  background: #ffff00;
}

.hightText {
  // color: #3366cc;
  background: #ffff00;
}

// .viewer-button {
//   height: 160px;

//   position: absolute;
//   right: -80px;
//   top: -80px;

//   width: 160px;
// }
.el-select-dropdown__wrap{
  max-height:500px !important;
}
.el-select-dropdown__item.selected{
  color:#DBB054 !important;
}
</style>





// WEBPACK FOOTER //
// src/App.vue